const Overlay = ({setOverlay}) => {


    return <div className="fixed top-0 left-0 z-[999] w-screen h-screen flex items-center justify-center">
        <div className='absolute inset-0 bg-slate-700 opacity-90' onClick={()=>setOverlay(false)}></div>
      
        <div className='p-4 bg-slate-900 rounded-xl relative z-50'>
            <iframe width="989" height="556" src="https://www.youtube.com/embed/qa5eP6lJkaQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

    </div>
}

export default Overlay